<template>
	<div class="login" :style="{height:height+'px'}">
		<div class="login_box">
			<div class="login_subtitle">欢迎登录！</div>
			<div class="login_title">5G靶向车环境综合检测平台</div>
			<div class="login_input"><img src="../assets/image/loginName.png"></img><input placeholder="请输入账号"
					v-model="account"></input>
			</div>
			<div class="login_input"><img src="../assets/image/loginPassword.png"></img><input placeholder="请输入密码"
					v-model="password" type="password"></input></div>
			<!-- <div class="login_sign"><span></span>记住密码</div> -->
			<div class="login_btn" @click="login">登录</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				height: `${document.documentElement.clientHeight}`,
				account: '',
				password: ''
			};
		},
		methods: {
			async login() {
				localStorage.removeItem("token")
				let result = await this.request.post("/v1.0/admin/loginByUsername", {
					username: this.account,
					password: this.password
				});
				if (result.code == 0) {
					console.log('result', result);
					localStorage.setItem("token", result.data.token);
					this.$notify({
						title: '登录成功',
						message: '登录成功',
						type: 'success'
					});
					sessionStorage.setItem("tabList",'[]')
					sessionStorage.setItem("isActiveNum",0)
					sessionStorage.setItem("path",'/VehicleHome')
					this.$router.push({
						path: '/VehicleHome'
					})
				}
			},
		}
	};
</script>

<style>
	.login {
		display: flex;
		justify-content: center;
		align-items: center;
		background: url(../assets/image/loginBG.png) no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
	}

	.login_box {
		width: 505px;
		height: 545px;
		background: url(../assets/image/loginBox.png) no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
	}

	.login_subtitle {
		margin: 74px 0 20px 60px;
		font-size: 22px;
		color: #06FFFD;
	}

	.login_title {
		margin-left: 60px;
		margin-bottom: 30px;
		font-size: 28px;
		font-weight: bold;
		color: #06FFFD;
	}

	.login_input {
		line-height: 80px;
		margin-left: 60px;
		width: 380px;
		border-bottom: 1px solid #06FFFD;
	}

	.login_input img {
		width: 15px;
		height: 19px;
		margin-top: -5px;
		margin-right: 20px;
	}

	.login_input input {
		border: none;
		background-color: transparent;
		font-size: 20px;
		color: #FFFFFF;
	}

	input:focus {
		border: none;
		outline: none
	}

	.login_sign {
		margin: 20px 0 25px 60px;
		color: #fff;
		font-size: 16px;
		line-height: 20px;
	}

	.login_sign span {
		width: 15px;
		height: 15px;
		border-radius: 50%;
		border: 1px solid #fff;
		float: left;
		margin-right: 18px;
		margin-top: 2px;
	}

	.login_btn {
		margin-top: 40px;
		background: url(../assets/image/loginBtn.png) no-repeat;
		background-size: cover;
		-webkit-background-size: cover;
		-o-background-size: cover;
		background-position: center 0;
		margin-left: 62px;
		width: 380px;
		height: 62px;
		line-height: 60px;
		color: #fff;
		font-size: 26px;
		text-align: center;
	}
</style>
